<template>
	<v-card>
		<v-card-title>
			<v-spacer />
			<v-spacer />
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="users"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<template #item.isPayed="{ item }">
				<v-icon v-if="item.isPayed" class="green--text">mdi-check</v-icon>
				<v-icon v-else class="red--text">mdi-alpha-x-circle</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>
<script>
import TrackModule from "@/store/modules/Track.module";
export default {
	name: "TrackTable",
	data() {
		return {
			loading: false,
			headers: [
				{ text: "שם", value: "name" },
				{ text: "אימייל", value: "email" },
				{ text: "האם שילם", value: "isPayed" }
			],
			lookingFor: null,
			showDialog: false
		};
	},
	computed: {
		project() {
			return this.$store.state.ProjectModule.project;
		},
		users() {
			return this.$store.state.TrackModule.tracks;
		}
	},
	watch: {
		async project(val) {
			if (val) {
				await this.$store.dispatch(
					TrackModule.types.FETCH_TRACKS,
					this.project.id
				);
			}
		}
	},
	methods: {}
};
</script>
